import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Loader from "../../../Generic/Loader";
import SearchBar from "../../../Generic/SearchBar";
import { errorNotification } from "../../../Generic/Notifications";
import OffersService from "../../Services/OffersService";

const SearchWrap = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	min-width: min(28rem, 80vw);
`;

const ResultsList = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;
	max-height: 16rem;
	overflow-y: auto;
	background: #fff;
	border: 1px solid rgba(0, 0, 0, 0.15);
	border-radius: 8px;
`;

const ResultItem = styled.li`
	padding: 0.75rem 1rem;
	cursor: ${(props) => (props.$disabled ? "default" : "pointer")};
	opacity: ${(props) => (props.$disabled ? 0.45 : 1)};
	border-bottom: 1px solid rgba(0, 0, 0, 0.08);
	color: #36395a;

	&:last-child {
		border-bottom: none;
	}

	&:hover {
		background: ${(props) => (props.$disabled ? "#fff" : "#f1f1f1")};
	}
`;

const StatusText = styled.p`
	margin: 0;
	color: rgba(0, 0, 0, 0.55);
	font-size: 0.9rem;
	text-align: center;
	padding: 1rem 0;
`;

const LoaderWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem 0;
`;

const MenuSearchModal = ({ selectedIds = [], onSelect }) => {
	const [query, setQuery] = useState("");
	const [results, setResults] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searched, setSearched] = useState(false);
	const requestIdRef = useRef(0);
	const selectedSet = new Set(selectedIds);

	useEffect(() => {
		const trimmed = query.trim();
		if (!trimmed) {
			setResults([]);
			setLoading(false);
			setSearched(false);
			return undefined;
		}

		const timerId = setTimeout(async () => {
			const requestId = ++requestIdRef.current;
			setLoading(true);
			const { data, error } = await OffersService.searchMenus(trimmed);
			if (requestId !== requestIdRef.current) return;
			setLoading(false);
			setSearched(true);
			if (error) {
				errorNotification(error);
				setResults([]);
				return;
			}
			setResults(data.menus || []);
		}, 400);

		return () => clearTimeout(timerId);
	}, [query]);

	return (
		<SearchWrap>
			<SearchBar
				value={query}
				onChange={(e) => setQuery(e.target.value)}
				placeholder="Search menus by name"
				autoFocus
			/>
			{loading ? (
				<LoaderWrap>
					<Loader />
				</LoaderWrap>
			) : !query.trim() ? (
				<StatusText>Type to search menus</StatusText>
			) : searched && results.length === 0 ? (
				<StatusText>No menus found</StatusText>
			) : (
				<ResultsList>
					{results.map((menu) => {
						const alreadySelected = selectedSet.has(menu._id);
						return (
							<ResultItem
								key={menu._id}
								$disabled={alreadySelected}
								onClick={() => {
									if (alreadySelected) return;
									onSelect?.(menu);
								}}>
								{menu.name}
							</ResultItem>
						);
					})}
				</ResultsList>
			)}
		</SearchWrap>
	);
};

export default MenuSearchModal;
